var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoadingFrame)?_c('div',{staticClass:"w-full flex items-center justify-center py-28"},[_c('AnnularThrobber')],1):_vm._e(),_vm._v(" "),_c('div',{class:{ 'opacity-0': _vm.isLoadingFrame },attrs:{"id":"benefits-frame"}})])}
var staticRenderFns = []

export { render, staticRenderFns }